<template>
  <div class="order-page">
    <div class="container">
      <div class="opera-btn-group">
        <el-form class="advanced-query-form">
          <el-row>
            <el-col :span="8">
              <oms-form-row :span="5" label="业务单据号">
                <oms-input placeholder="请输入业务单据号" type="text" v-model="searchCondition.objectNo"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="10">
              <oms-form-row :span="5" label="业务时间范围">
                <el-col :span="24">
                  <el-date-picker
                    v-model="bizDateAry"
                    type="datetimerange"
                    :default-time="['00:00:00', '23:59:59']"
                    placeholder="请选择">
                  </el-date-picker>
                </el-col>
              </oms-form-row>
            </el-col>
            <el-col :span="6">
              <oms-form-row :span="6" label="业务类型">
                <el-select filterable placeholder="请选择业务类型" v-model="searchCondition.bizType">
                  <el-option :key="item.key" :label="item.label" :value="item.key" v-for="item in outBizTypes"/>
                </el-select>
              </oms-form-row>
            </el-col>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="8">
              <oms-form-row :span="5" label="来源单位">
                <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索来源单位"
                            v-model.trim="searchCondition.sourceOrgId" :list="downOrgList"/>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="6" label="去向单位">
                <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索去向单位"
                            v-model.trim="searchCondition.directionOrgId" :list="downOrgList"/>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="1" label="">
                <el-button @click="searchInOrder" plain type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
                <perm label="code-biz-out-trace-count-export" style="margin-left: 10px">
                  <el-button :disabled="isLoading" :plain="true" type="success" @click="exportFile">
                    导出汇总
                  </el-button>
                </perm>
                <perm label="code-biz-in-trace-detail-count-export" style="margin-left: 10px">
                  <el-button :disabled="isDetailLoading" :plain="true" type="success" @click="exportDetailFile">
                    导出明细汇总
                  </el-button>
                </perm>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="2">业务类型</el-col>
          <el-col :span="4">业务单据号</el-col>
          <el-col :span="5">来源单位</el-col>
          <el-col :span="5">去向单位</el-col>
          <el-col :span="3">业务时间</el-col>
          <el-col :span="3">创建时间</el-col>
          <el-col :span="2">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentOrderId===item.id}]" @click.prevent="showItem(item)"
               class="order-list-item order-list-item-bg"
               v-for="item in orderList">
            <el-row type="flex">
              <el-col :span="2">{{ filterBizType(item.bizType) }}</el-col>
              <el-col :span="4" class="R">{{ item.objectNo }}</el-col>
              <el-col :span="5">{{ item.sourceOrgName }}</el-col>
              <el-col :span="5">{{ item.directionOrgName }}</el-col>
              <el-col :span="3">{{ item.operateTime | minute }}</el-col>
              <el-col :span="3">{{ item.createTime | minute }}</el-col>
              <el-col :span="2">
                <des-btn perm="code-biz-out-trace-edit" @click="edit(item)" icon="edit">编辑</des-btn>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="(orderList.length) && !loadingData">
      <el-cu-pagination :current-page="pager.currentPage" :page-size="20"
                        :page-sizes="[20,50,100]"
                        :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                        layout="sizes, prev, pager, next, jumper">
      </el-cu-pagination>
    </div>
    <page-right :css="{'width':'1000px','padding':0}" :show="showDetail" @right-close="resetRightBox"
                class="order-detail-info" partClass="pr-no-animation">
      <show-form :filterBizType="filterBizType" :orderId="currentOrderId" @close="resetRightBox"
                 @deleteItem="deleteItem"></show-form>
    </page-right>
    <page-right :css="{'width':'1000px','padding':0}" :show="showEdit" @right-close="resetRightBox"
                class="order-detail-info" partClass="pr-no-animation">
      <edit-form :filterBizType="filterBizType" :currentOrder="currentOrder" @close="resetRightBox"
                 @change="refreshList"></edit-form>
    </page-right>
  </div>
</template>
<script>
import showForm from './form/show.form.vue';
import editForm from './form/edit.form.vue';
import {bizTraces} from '@/resources';
import DataMixin from '@/mixins/dataMixin';
import MethodsMix from "@/mixins/methodsMinix";
import utils from "@/tools/utils";

export default {
  components: {showForm, editForm},
  mixins: [DataMixin, MethodsMix],
  data: function () {
    return {
      isLoading: false,
      isDetailLoading:false,
      loadingData: true,
      showDetail: false,
      showEdit: false,
      showSearch: true,
      bizDateAry: '',
      orderList: [],
      filters: {
        orgId: '',
        objectNo: '',
        bizType: '',
        sourceOrgId: '',
        directionOrgId: '',
        operateStartTime: '',
        operateEndTime: ''
      },
      searchCondition: {
        orgId: '',
        objectNo: '',
        bizType: '',
        sourceOrgId: '',
        directionOrgId: '',
        operateStartTime: '',
        operateEndTime: ''
      },
      activeStatus: 0,
      currentOrderId: '',
      pager: {
        currentPage: 1,
        count: 0,
        pageSize: 20
      },
      currentOrder: {}
    };
  },
  mounted() {
    this.getOrderList(1);
  },
  watch: {
    filters: {
      handler: function () {
        // this.getOrderList(1);
      },
      deep: true
    }
  },
  computed: {
    outBizTypes: function () {
      let bizTypes = this.$getDict('bspBizType') || [];
      return bizTypes.filter(f => {
        return f.key.startsWith('2');
      });
    }
  },
  methods: {
    exportDetailFile: function () {
      this.searchInOrder();
      let params = Object.assign({}, this.searchCondition);
      this.$store.commit('initPrint', {
        isPrinting: true,
        moduleId: '/search/business-out'
      });
      this.isLoading=true;
      this.$http.get('code-biz/out-order/export-detail-count', {params}).then(res => {
        utils.download(res.data.path);
        this.$store.commit('initPrint', {
          isPrinting: false,
          moduleId: '/search/business-out'
        });
        this.isLoading=false;
      }).catch(error => {
        this.$store.commit('initPrint', {
          isPrinting: false,
          moduleId: '/search/business-out'
        });
        this.isLoading=false;
        this.$notify.error({
          message: error.response && error.response.data && error.response.data.msg || '导出失败'
        });
      });
    },
    exportFile: function () {
      this.searchInOrder();
      let params = Object.assign({}, this.searchCondition);
      this.$store.commit('initPrint', {
        isPrinting: true,
        moduleId: '/search/business-in'
      });
      this.isLoading = true;
      this.$http.get('code-biz/out-order/export-count', {params}).then(res => {
        utils.download(res.data.path);
        this.$store.commit('initPrint', {
          isPrinting: false,
          moduleId: '/search/business-in'
        });
        this.isLoading = false;
      }).catch(error => {
        this.$store.commit('initPrint', {
          isPrinting: false,
          moduleId: '/search/business-in'
        });
        this.isLoading = false;
        this.$notify.error({
          message: error.response && error.response.data && error.response.data.msg || '导出失败'
        });
      });
    },
    deleteItem() {
      this.resetRightBox();
      this.getOrderList(this.pager.currentPage);
    },
    searchInOrder: function () {// 搜索
      this.searchCondition.operateStartTime = this.$formatAryTime(this.bizDateAry, 0);
      this.searchCondition.operateEndTime = this.$formatAryTime(this.bizDateAry, 1);
      Object.assign(this.filters, this.searchCondition);
      this.getOrderList(1);
    },
    resetSearchForm: function () {// 重置表单
      let temp = {
        orgId: '',
        objectNo: '',
        bizType: '',
        sourceOrgId: '',
        directionOrgId: '',
        operateStartTime: '',
        operateEndTime: ''
      };
      Object.assign(this.searchCondition, temp);
      Object.assign(this.filters, temp);
      this.bizDateAry = '';
      this.getOrderList(1);
    },
    resetRightBox: function () {
      this.showDetail = false;
      this.showEdit = false;
      // this.$router.push('/search/business');
    },
    refreshList() {
      this.currentOrderId = '';
      this.getOrderList(this.pager.currentPage);
    },
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.getOrderList(1);
    },
    handleCurrentChange(val) {
      this.getOrderList(val);
    },
    getOrderList: function (pageNo) {
      if (pageNo === 1) {
        this.pager.count = 0;
      }
      this.pager.currentPage = pageNo;
      let param = {};
      this.loadingData = true;
      param = Object.assign({}, this.filters, {
        pageNo: pageNo,
        pageSize: this.pager.pageSize
      });
      bizTraces.queryOutOrder(param).then(res => {
        this.orderList = res.data.list;
        this.pager.count = this.pager.currentPage * this.pager.pageSize + (this.orderList.length === this.pager.pageSize ? 1 : 0);
        this.loadingData = false;
      });
    },
    edit: function (order) {
      this.currentOrderId = order.id;
      this.getOrderInfo(this.currentOrderId);
      this.showEdit = true;
    },
    getOrderInfo: function (val) {
      if (!val) return;
      bizTraces.get(val).then(res => {
        this.currentOrder = res.data;
      });
    },
    showItem: function (order) {
      this.currentOrderId = order.id;
      this.showDetail = true;
      // this.$router.push(`/search/business/${order.id}`);
    },
    formatTimeAry(times, index, str) {
      if (!times) return;
      return this.formatTime(times[index], str);
    },
    formatTime(time, str = 'YYYY-MM-DD HH:mm:ss') {
      return time ? this.$moment(time).format(str) : '';
    }
  }
};
</script>
